import createIcon from '@/lib/create-icon'

const MenuIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
    <path d='M17.0612 4H2.93881C2.42032 4 2 4.40361 2 4.90149C2 5.39937 2.42032 5.80298 2.93881 5.80298H17.0612C17.5797 5.80298 18 5.39937 18 4.90149C18 4.40361 17.5797 4 17.0612 4Z' />
    <path d='M14.6502 9.09676H2.93881C2.42032 9.09676 2 9.50037 2 9.99825C2 10.4961 2.42032 10.8997 2.93881 10.8997H14.6502C15.1687 10.8997 15.589 10.4961 15.589 9.99825C15.589 9.50037 15.1687 9.09676 14.6502 9.09676Z' />
    <path d='M10.8877 14.197H2.93881C2.42032 14.197 2 14.6006 2 15.0985C2 15.5964 2.42032 16 2.93881 16H10.8877C11.4062 16 11.8265 15.5964 11.8265 15.0985C11.8265 14.6006 11.4062 14.197 10.8877 14.197Z' />
  </svg>,
  'MenuIcon'
)

export default MenuIcon
